import { NgModule } from '@angular/core';
import { CustomerComponent } from './customer.component';
import { EditComponent } from './components/edit/edit.component';
import { CommonModule } from '@angular/common';
import { CustomerRoutingModule } from './customer-routing.module';
import { SharedModule } from '../shared.module';

@NgModule({
    declarations: [
        CustomerComponent, EditComponent
    ],
    imports: [
        CustomerRoutingModule, CommonModule, SharedModule
    ],
    exports: [
        CustomerComponent, EditComponent
    ]

})
export class CustomerModule { }
